import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';

export class GoalTypeColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, s$i18n, recommendationType }) {
    let sortable = false;
    if (recommendationType === RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS) {
      sortable = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.FixConversionGoalSettingsOpportunitySummary/GoalTypeCode';
    } else if (recommendationType === RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL) {
      sortable = 'Microsoft.Advertiser.AdInsight.Opportunity.Schema.CreateConversionGoalOpportunitySummary/GoalType';
    }
    super({
      name: 'GoalTypeName',
      property: 'GoalTypeName',
      title: i18n.getString('Details_View_Goal_Type_Name'),
      bodyClasses: ['grid-column-goalTypeName', 'actionable'],
      colClasses: ['col-normalText'],
      sortable,
      type: 'string',
      helpId: 'pop_BA_UET_Type',
    });
    this.s$i18n = s$i18n;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    let goalType;
    if (Opportunities[0].GoalTypeCode === 'DestinationGoal') {
      goalType = 'DestinationGoal';
    } else if (Opportunities[0].GoalTypeCode === 'EventGoal') {
      goalType = 'EventGoal';
    } else if (Opportunities[0].GoalTypeCode === 'ClarityEventGoal') {
      goalType = 'EventGoal';
    }
    return this.s$i18n.value('Goal', 'Type', goalType);
  }

  get property() {
    return {
      get: _.identity,
      property: 'GoalTypeName',
    };
  }
}
